export default "__VITE_ASSET__rwtRByM4__"